
    <div class="main-component-wrapper flex flex-row justify-start itmes-center">
      <div  class="full basis-full">
        <router-outlet></router-outlet>
      </div>
    </div>

